import React, { useEffect, useState } from 'react'
import { constants } from '../common/constants'
import axios from 'axios'
import {withRouter} from 'react-router-dom'
import RecaptchaV2 from '../components/RecaptchaV2/recaptchaV2'
import {withGoogleReCaptcha} from 'react-google-recaptcha-v3'
import {connect} from 'react-redux'
import DropdownCountry from '../components/DropdownCountry'
import DropdownRegion from '../components/DropdownRegion'
import ButtonLoading from '../components/ButtonLoading'
import Script from 'react-load-script'
import RecurlyBillingInfo from './RecurlyBillingInfo'

const mapStateToProps = (globalStore) => {return {store: globalStore}}
const mapDispatchToProps = (dispatch) => {return {
  customerSubscription: (transactionRecord) => {dispatch({type: 'CUSTOMER_SUBSCRIPTION', payload: transactionRecord})}
}}

const RecurlyPaymentForm = ({
  options,
  getPlans,
  ...props
}) => {

  const [ paymentScriptLoaded, setPaymentScriptLoaded ] = useState(false)
  const [ isLoading, setIsLoading ] = useState(false)
  const [ errorMessage, setErrorMessage ] = useState('')

  const [ country, setCountry ] = useState('')
  const [ state, setState ] = useState('')
  const [ recaptchaV2Response, setRecaptchaV2Response ] = useState('')

  useEffect(() => {

    if(!paymentScriptLoaded) return;

    window.recurly.configure({
      publicKey: constants.recurlyPublicKey
    })
  }, [paymentScriptLoaded])
  
  const handleSubmit = async ({}) => {

    try {

      setIsLoading(true)

      if(options.purpose === 'update') {
        await handleUpdateRecurlySubscription({
          targetPlan: options.targetPlan,
          currentPlan: options.currentPlan
        })

        setTimeout(() => {
          setIsLoading(false)
          window.location.reload()
        }, 2000)
      }
      
      if(window.recurly?.token) {
        window.recurly.token(document.querySelector('#recurlyForm'), async (err, token) => {

          try {
            const recaptchaV3Response = await props.googleReCaptchaProps.executeRecaptcha('forgotPassword')

            if(err) {
              setErrorMessage('Declined - please check your input');
              return;
            }
    
            if(options.purpose === 'checkout') {
              await handleCheckout({
                recaptchaV3Response,
                token
              })
              setIsLoading(false)
              return;
            }
    
            if(options.purpose === 'change-payment-method') {
              await handleChangePaymentMethod({
                recaptchaV3Response,
                token
              })
              setIsLoading(false)
            }

            if(options.purpose === 'checkout-register') {
              handleCheckoutRegister({
                token
              })
              return;
            }

            setTimeout(() => {
              setIsLoading(false)
              window.location.reload()
            }, 2000)
    
          } catch(e) {
            setIsLoading(false)

          } finally {
            setIsLoading(false)
          }
        })
      }

    } catch(e) {
      setIsLoading(false)
    }
  }

  const handleChangePaymentMethod = async ({
    recaptchaV3Response,
    token
  }) => {

    const payload = {
      planId: options.targetPlan.planId, 
      paymentToken: token?.id ?? null,
      recaptchaV3Response,
      recaptchaV2Response
    }

    await axios.post('/customer/plan/changePaymentMethod', payload);
  }

  const handleCheckout = async ({
    recaptchaV3Response,
    token
  }) => {

    try {
      const payload = {
        planId: options.targetPlan.planId, 
        paymentToken: token?.id ?? null,
        recaptchaV3Response,
        recaptchaV2Response
      }
  
      const response = await axios.post('/customer/plan/checkoutNew', payload);
      props.customerSubscription(response.data.data)
      props.history.push('/done/newSubscription')
    } catch(e) {
      if(e.response) {
        setErrorMessage(e.response?.data?.message || 'An error occurred, please try again later')
      }
    }
  }

  const handleCheckoutRegister = async ({
    token
  }) => {
    const registerObject = {
      registerFromPlan: true, 
      paymentToken: token?.id ?? null, 
      plan: options.targetPlan
    }

    // Construct the new route with the plan code and register object
    const newRoute = `/register/${options.targetPlan.planCode}`;

    // Retrieve current query parameters
    const queryParams = props.location.search;

    // Push the new route along with the current query parameters
    props.history.push(newRoute + queryParams, registerObject);     
  }

  const handleUpdateRecurlySubscription = async ({
    targetPlan, 
    currentPlan
  }) => {

    const DOWNGRADE_PLAN = targetPlan.planPriority < currentPlan.planPriority
    const CANCEL_PLAN = ['free'].includes(targetPlan.planCode.toLowerCase()) && DOWNGRADE_PLAN
    const UPGRADE_PLAN = targetPlan.planPriority > currentPlan.planPriority

    const payload = {
      newPlanId: targetPlan.planId
    }

    if(CANCEL_PLAN) {
      await axios.post('/customer/plan/cancel', payload)
    }
    else if (DOWNGRADE_PLAN) {
      await axios.post('/customer/plan/downgrade', payload)
    }
    else if (UPGRADE_PLAN) {
      await axios.post('/customer/plan/upgrade', payload)
    }
  }
  
  const handleVerifyRecaptchaV2 = (response) => {
    setRecaptchaV2Response(response)
  }

  const loaded = () => {
    setPaymentScriptLoaded(true)
  }

  if(!options.purpose) {
    return null
  }

  if(options.purpose === 'update') {
    return (
      <div>
        <div className="plan-prompt">
          <div className="plan-prompt-title">You have chosen to switch from {options.currentPlan.planName} to {options.targetPlan.planName}.</div>
          {
            options.targetPlan.planPriority < options.currentPlan.planPriority ?
              <div className="plan-prompt-p">The new plan will take effect at the end of your current billing cycle, at which point you will be billed the new rate. Are you sure you wish to switch?</div> :
              <div className="plan-prompt-p">The switch will take effect immediately. If the new plan costs more than the existing plan, you will be charged the difference in costs, pro-rated to the amount of days left in your billing cycle.</div>
          }
        </div>
        <div className="btn btn-sm btn-primary" onClick={isLoading ? ()=>{} : handleSubmit}>{isLoading ? <ButtonLoading/> : 'Submit'}</div> 
      </div>  
    )
  }

  return (
    <>
      <Script url="https://js.recurly.com/v4/recurly.js" onLoad={loaded.bind(this)} />
      <div>
        {
          props.store.isLoggedIn && <RecurlyBillingInfo />
        }
      </div>
      { options.purpose === 'change-payment-method' && <div className="plan-prompt-title"> Change your billing information </div> }
      <div className="plan-payment-form">
        <form id="recurlyForm">
          <div data-recurly="card" />
          <div className="plan-payment-spacer">&nbsp;</div>
          <input type="text" data-recurly="first_name" className="form-control plan-payment-input" placeholder="First Name"/>
          <input type="text" data-recurly="last_name"  className="form-control plan-payment-input"  placeholder="Last Name"/>
          <input type="text" data-recurly="address1"  className="form-control plan-payment-input"  placeholder="Street Address"/>
          <input type="text" data-recurly="city" className="form-control plan-payment-input" placeholder="City"/>
          <input type="text" data-recurly="postal_code"  className="form-control plan-payment-input" placeholder="Postal Code"/>
          <DropdownCountry data-recurly="country" className="form-control plan-payment-input" autoComplete="country" onChange={(value)=>{if(country!==value) setCountry(value);}} value={country} />
          <DropdownRegion data-recurly="state" className="form-control plan-payment-input" autoComplete="address-level1" country={country} value={state} onChange={(val)=>{setState(val)}} />
          <div className="plan-payment-text">Membership subscriptions renew automatically until cancellation by re-activating the free plan. When cancelled, the membership will end on the next renewal date. No refunds are provided for early cancellations.</div>
          <input type="hidden" name="recurly-token" data-recurly="token" />
          {!!errorMessage && <div className="error-text">{errorMessage}</div>}
          <div className="mt-3 mb-2">
            <div className="form-group">
              <RecaptchaV2 onVerify={handleVerifyRecaptchaV2}/>
            </div>
            { <div className="btn btn-primary" style={{ pointerEvents: !!recaptchaV2Response ? 'auto' : 'none' }} onClick={isLoading ? ()=>{} : handleSubmit}>{isLoading ? <ButtonLoading/> : 'Submit'}</div> }
            <div className="plan-payment-text text-center mt-1">By submitting, you agree to our <a target="_blank" rel="noopener noreferrer" href={constants.appHome+'/terms-and-conditions'}>terms & conditions</a></div>
          </div>
        </form>
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withGoogleReCaptcha(RecurlyPaymentForm)))
